const isInputFilled = (input) => {
  if (!input) return false;
  const value = input.value;
  if (value === null || value === undefined) return false;
  if (typeof value === "string" && value.trim() === "") return false;
  return true;
};

export const getDocumentationFieldChips = (clientDocumentation) => {
  const chips = [];
  const docType = clientDocumentation && clientDocumentation.documentationType;
  if (!docType) return chips;

  if (docType.needsFileUpload) {
    chips.push({
      name: "Ficheiro",
      filled: !!(clientDocumentation.files && clientDocumentation.files.length),
    });
  }

  if (docType.inputs && Array.isArray(docType.inputs)) {
    docType.inputs.forEach((input) => {
      chips.push({
        name: input.name || `Input ${input.id}`,
        filled: isInputFilled(input),
      });
    });
  }

  return chips;
};

export const getDocumentationDocStatus = (clientDocumentation) => {
  const chips = getDocumentationFieldChips(clientDocumentation);
  if (!chips.length) return "success";
  const missing = chips.filter((chip) => !chip.filled).length;
  if (missing === 0) return "success";
  if (missing === chips.length) return "error";
  return "warning";
};

export const getDocumentationDocStatusLabel = (status) => {
  if (status === "success") return null;
  if (status === "error") return "Crítico";
  return "Pendentes";
};

export const countIncompleteDocumentations = (docs) =>
  (docs || []).filter((doc) => getDocumentationDocStatus(doc) !== "success")
    .length;
